import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AuthService } from 'src/app/core/services/auth.service';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { HttpService } from 'src/app/core/services/api/http.service';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { ValidationService } from 'src/app/core/services/validation.service';
import { ThirdPartiesApiService } from 'src/app/core/services/api/third-parties-api.service';
import { Observable, finalize, take } from 'rxjs';
import { ApiResponse } from '../../models/api-response.interface';
import { ThirdPartyFullObject } from '../../models/third-party.interface';
import { UsersGroup } from '../../enums/users-group.enum';
import { Auto_Complete } from '../../../core/services/auto-complete';
import { InputFieldType } from '../../models/input-types.enum';
import { API_VERSIONS } from '../../consts/api-versions.const';
import { NavigationTab } from '../../enums/navigation-tab';

@Component({
  selector: 'app-sub-client-form',
  templateUrl: './sub-client-form.component.html',
  styleUrls: ['./sub-client-form.component.css'],
})
export class SubClientFormComponent implements OnInit {
  @ViewChild('permissions') permissions!: ElementRef;
  addUserForm!: FormGroup;
  addEditUserPopup: boolean = false;
  isAddNew: boolean = false;
  userId: number = 0;
  loadingSubmit: boolean = false;
  // when canceling popup from outside of cancel button open discard popup
  @ViewChild('messageComponent', { static: false }) messageComponent: any;
  loadingConfirm: boolean = false;

  maxDate: any;

  selectedProducts: any = [];
  selectedProdIds: any;
  isLoadingTheProducts: boolean = false;
  allProducts: any;
  isChangeOrders: boolean = false;
  isLoading: boolean = false;
  isSubUserForm: boolean = false;

  clientsCreatedList: any;
  userObj = this._auth.getUserObj() || {};

  @Output('onAddEditDealer') onAddEditDealer =
    new EventEmitter<String | null>();
  @Input('whoEntered') whoEntered: {
    form: string;
    from: string;
    createdUsers: string;
  } = { form: 'Dealer', from: 'admin', createdUsers: 'Agents' };

  productFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.PRODUCTS}/products`,
    true
  );
  parentFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.USERS}/users`,
    true,
    false,
    true,
    'global_search'
  );
  clientsCreatedFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.USERS}/users`,
    true,
    false,
    true,
    'search_by_third_party'
  );

  protected readonly navigationTabs = [
    {
      name: 'Information',
      id: NavigationTab.Information_Agent,
    },
    {
      name: 'Dealerships',
      id: NavigationTab.Dealerships_Agent,
    },
    {
      name: 'Products',
      id: NavigationTab.Products_Agent,
    },
    {
      name: 'Commissions',
      id: NavigationTab.Commissions_Agent,
    },
    {
      name: 'Claims',
      id: NavigationTab.Claims_Agent,
    },
    {
      name: 'Contracts',
      id: NavigationTab.Contracts_Agent,
    },
  ];
  protected readonly Validators = Validators;
  protected readonly InputFieldType = InputFieldType;

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private validationService: ValidationService,
    private _api: HttpService,
    private _auth: AuthService,
    private notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private errHandle: ErrorHandlingService,
    private thirdPartiesService: ThirdPartiesApiService,
    public _pService: PermissionsService
  ) {}

  ngOnInit(): void {
    this.productFilter.options = {
      ...this.productFilter.options,
      include_atlantic_products: true,
    };
    this.initForm();
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['openPopup']) {
        // this.addEditUserPopup = true;
        this.openAddEditPopup(true);
        this.loadFormValuesFromLocalStorage();
      } else {
        if (this._pService.hasListPermissions(['update_user', 'create_user'])) {
          // this.getOnboarding();
        }
        if (this.whoEntered.from == 'admin') {
          this.getAllGroupsUsers();
        }
      }
    });
  }

  get parent_id() {
    return this.addUserForm.get('parent_id');
  }
  get fname() {
    return this.addUserForm.get('fname');
  }
  get lname() {
    return this.addUserForm.get('lname');
  }
  get email() {
    return this.addUserForm.get('email');
  }
  get client_name() {
    return this.addUserForm.get('client_name');
  }
  get internal_code() {
    return this.addUserForm.get('internal_code');
  }
  get created_name() {
    return this.addUserForm.get('created_name');
  }

  get products() {
    return this.addUserForm.get('products');
  }

  getAllGroupsUsers(): void {
    if (this.whoEntered.createdUsers === 'Agents') {
      this.clientsCreatedFilter.options = {
        filter_by_group: UsersGroup.Agents,
      };
    } else if (this.whoEntered.createdUsers === 'Brokers') {
      this.clientsCreatedFilter.options = {
        filter_by_group: UsersGroup.Brokers,
      };
    }
  }

  getUserGroupId() {
    switch (this.whoEntered.form) {
      case 'Agent': {
        return UsersGroup.Brokers;
      }
      case 'Dealer': {
        return UsersGroup.Agents;
      }
      default:
        return UsersGroup.Dealers;
    }
  }

  getParentGroupId() {
    switch (this.whoEntered.form) {
      case 'Agent': {
        return UsersGroup.Agents;
      }
      case 'Broker': {
        return UsersGroup.Brokers;
      }
      default:
        return UsersGroup.Dealers;
    }
  }

  saveDataInLocalStorage() {
    Object.keys(this.addUserForm.controls).forEach((key) => {
      const control = this.addUserForm.get(key);
      if (control?.value) {
        if (key === 'formArray') {
          let values = control?.value;
          values = values.filter((value: any) => value.check === true);
          if (values?.length > 0) {
            localStorage.setItem(key, JSON.stringify(values));
          }
        } else if (key === 'products') {
          if (control?.value?.length > 0) {
            localStorage.setItem(key, JSON.stringify(control?.value));
          }
        } else if (key === 'created_name') {
          if (control?.value) {
            localStorage.setItem(key, JSON.stringify(control?.value));
          }
        } else if (key === 'formAddress') {
          //
          if (control?.value?.street_address?.label) {
            localStorage.setItem(key, JSON.stringify(control?.value));
          }
        } else {
          localStorage.setItem(key, control?.value);
        }
        //
      }
    });
    this.router.navigate(
      [
        '/dashboard/clients/' +
          this.whoEntered.form.toLocaleLowerCase() +
          '/settings/onboarding-forms/add',
      ],
      { queryParams: { source: 'from-popup' } }
    );
  }

  loadFormValuesFromLocalStorage() {
    let isSelectOnboard = false;
    Object.keys(this.addUserForm.controls).forEach((key) => {
      const control: any = this.addUserForm.get(key);
      const storedValue = localStorage.getItem(key);
      if (storedValue) {
        if (key === 'products' || key === 'formAddress') {
          const parsedValue = JSON.parse(storedValue);
          if (parsedValue) {
            setTimeout(() => {
              control?.setValue(parsedValue);
            }, 0);
          }
        } else if (key === 'formArray') {
          const parsedValue = JSON.parse(storedValue);
          //
          isSelectOnboard = true;
        } else {
          control?.setValue(storedValue);
        }
      }
    });
    if (!isSelectOnboard) {
      // this.getOnboarding();
    }
    this.addUserForm.markAsUntouched();
  }

  clearFormValuesFromLocalStorage() {
    Object.keys(this.addUserForm.controls).forEach((key) => {
      localStorage.removeItem(key);
    });
  }
  //to handling looping on form arrays in html
  getFormsArray(form: any) {
    return form?.controls;
  }

  get formAddress(): FormGroup {
    return this.addUserForm.get('formAddress') as FormGroup;
  }

  openAddEditPopup(
    isAddNew: boolean,
    user?: any,
    parent?: ThirdPartyFullObject
  ) {
    if (parent) {
      this.isSubUserForm = true;
      this.addUserForm.addControl('parent_id', new FormControl(parent));
      this.addUserForm.addControl(
        'enable_claim_creation_notification',
        new FormControl(false)
      );
      this.addUserForm.addControl(
        'enable_claim_status_update_notification',
        new FormControl(false)
      );
      this.addUserForm.addControl(
        'enable_claim_agent_change_notification',
        new FormControl(false)
      );
      this.parentFilter.options = { filter_by_group: this.getParentGroupId() };
    }
    if (!isAddNew) {
      let validUsMobile = '';
      if (user?.phone_number) {
        const mobile = user?.phone_number?.slice(2);
        validUsMobile = `(${mobile.slice(0, 3)}) ${mobile.slice(
          3,
          6
        )}-${mobile.slice(6)}`;
      }
      this.userId = user?.id;
      this.addUserForm.patchValue({
        fname: user?.first_name,
        lname: user?.last_name,
        email: user?.email,
        phone: validUsMobile,
        client_name: user?.third_party_info?.third_party_name,
      });
      this.isLoadingTheProducts = true;
      this._api.getReq(`/users/${user?.id}`).subscribe(
        (res) => {
          this.addUserForm.patchValue({
            send_invitation: !!user?.send_invitation,
          });
          if (res?.data?.third_party_info?.third_party_name) {
            this.addUserForm.patchValue({
              client_name: res?.data?.third_party_info?.third_party_name,
            });
          }

          const parent = res?.data?.parent;
          if (parent) {
            this.addUserForm.patchValue({
              parent_id: parent,
            });
            this.addUserForm.patchValue({
              enable_claim_creation_notification:
                !!res?.data?.enable_claim_creation_notification,
              enable_claim_status_update_notification:
                !!res?.data?.enable_claim_status_update_notification,
              enable_claim_agent_change_notification:
                !!res?.data?.enable_claim_agent_change_notification,
            });
          }

          if (res?.data?.third_party_info?.internal_code) {
            this.addUserForm.patchValue({
              internal_code: res?.data?.third_party_info?.internal_code,
            });
          }

          const selectedProds = res?.data?.third_party_info?.products;
          if (selectedProds) {
            this.selectedProdIds = selectedProds.map((product: any) => {
              return { id: product?.id, label: product?.label };
            });
            this.allProducts?.forEach((product: any) => {
              this.selectedProdIds?.includes(product.id)
                ? this.selectedProducts.push(product)
                : null;
            });
            this.addUserForm.patchValue({
              products: res?.data?.third_party_info?.products,
              created_name: res?.data?.supervisor,
            });
            const streetAddressObj = {
              label:
                res?.data?.third_party_info?.contact_details?.address_details
                  ?.address,
              type: 'Container',
            };
            this.formAddress.patchValue({
              street_address: streetAddressObj,
              country:
                res?.data?.third_party_info?.contact_details?.address_details
                  ?.country,
              city: res?.data?.third_party_info?.contact_details
                ?.address_details?.city,
              state:
                res?.data?.third_party_info?.contact_details?.address_details
                  ?.state,
              zip_code:
                res?.data?.third_party_info?.contact_details?.address_details
                  ?.zip_code,
            });
            this.isLoadingTheProducts = false;
          }
        },
        (err) => {
          this.errHandle.errorHandling(err);
          this.isLoadingTheProducts = false;
        }
      );
    } else {
      this.email?.enable();
      if (parent) {
        this.addUserForm.patchValue({
          parent_id: parent,
        });
        this.fname?.setValue('');
        this.lname?.setValue('');
      }
    }
    this.isAddNew = isAddNew;
    this.addEditUserPopup = true;
    if (isAddNew) {
      // this.getOnboarding();
    }
    this.getProducts();
    this.selectedProducts = [];
  }

  getProducts() {
    this.isLoadingTheProducts = true;
    this._api
      .getReq(
        `/${API_VERSIONS.PRODUCTS}/products?include_atlantic_products=true`
      )
      .subscribe(
        (res) => {
          const allProducts = res?.data ? res?.data : [];
          this.allProducts = allProducts.map((item: any) => ({
            id: item?.id,
            label: item?.label,
          }));
          if (this.allProducts?.length === 0) {
            this.allProducts = [{ id: 0, label: 'No matching Products' }];
          }
          if (!this.isAddNew) {
            this.allProducts?.forEach((product: any) => {
              this.selectedProdIds?.includes(product.id)
                ? this.selectedProducts.push(product)
                : null;
            });
          }

          this.isLoadingTheProducts = false;
        },
        (err) => {
          this.isLoadingTheProducts = false;
          this.errHandle.errorHandling(err);
        }
      );
  }

  saveUser(): void {
    if (this.addUserForm.invalid) {
      this.addUserForm.markAllAsTouched();
      return;
    }
    this.loadingSubmit = true;
    const payload = this.mapPayload();

    const request$: Observable<ApiResponse> = this.isAddNew
      ? this._api.postReq(`/member/${this.whoEntered.form}`, payload)
      : this._api.putReq(`/member/${this.userId}`, payload);

    request$
      .pipe(
        take(1),
        finalize(() => (this.loadingSubmit = false))
      )
      .subscribe({
        next: (result: ApiResponse) => {
          this.onHide(true);
          this.notificationService.success('Success', result?.message);
          this.addEditUserPopup = false;
          this.addUserForm.reset();
          this.onAddEditDealer.emit(this.isAddNew ? 'add' : 'update');
          if (this.isAddNew) {
            this.clearFormValuesFromLocalStorage();
          }
        },
        error: (error) => this.errHandle.errorHandling(error),
      });
  }

  private mapPayload(): any {
    const formValue = this.addUserForm.value;
    let phoneNumber = formValue.phone
      ? formValue.phone
          .split(') ')
          .join('')
          .split('-')
          .join('')
          .split('(')
          .join('')
      : '';
    let payload: any = {
      group: this.whoEntered.form,
      phone_number: '+1' + phoneNumber,
      email: this.email?.value,
      send_invitation: this.isAddNew ? !!formValue.send_invitation : false,
      parent_id: this.parent_id?.value?.id,
      enable_claim_creation_notification:
        formValue.enable_claim_creation_notification,
      enable_claim_status_update_notification:
        formValue.enable_claim_status_update_notification,
    };

    if (this.fname?.value) {
      payload['first_name'] = this.fname?.value;
    }
    if (this.lname?.value) {
      payload['last_name'] = this.lname?.value;
    }
    if (!this.email?.value) {
      delete payload['email'];
    }
    if (!this.userId) {
      payload['navigation_tab_ids'] = formValue.navigation_tab_ids;
    }

    return payload;
  }

  onHide(shouldUpdateList = false) {
    this.addUserForm.patchValue({
      fname: '',
      lname: '',
      email: '',
      created_name: '',
      contract_name: '',
      phone: '',
      client_name: '',
      products: '',
    });
    this.selectedProdIds = [];
    this.addUserForm.markAsUntouched();
    this.addUserForm.markAsPristine();
    this.addEditUserPopup = false;
    if (shouldUpdateList) {
      this.router.navigate([]);
    }
  }

  // open confirmation popup in case the user click on cancel or outside the popup
  accepted() {
    this.messageComponent.close();
    // this.addUserForm.reset();
    this.onHide();
    this.addEditUserPopup = false;
    this.addUserForm.reset();
    this.clearFormValuesFromLocalStorage();
  }

  rejected() {
    this.messageComponent.close();
  }

  closeModalOutside(event: any) {
    // if the form not dirty it's not important to show the discard message
    if (this.addUserForm.dirty) {
      this.messageComponent.open();
    } else {
      this.accepted();
    }
  }

  //handle drag and drag sections
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex != event.currentIndex) {
      moveItemInArray(
        this.optionsFormArray.controls,
        event.previousIndex,
        event.currentIndex
      );
      this.isChangeOrders = true;
    }
  }

  get optionsFormArray(): FormArray {
    return this.addUserForm.get('formArray') as FormArray;
  }

  sliceCreatedUser(user: string) {
    // Brokers return Broker without (s)
    return user.slice(0, user?.length - 1);
  }

  suggestions: any = [];
  onQueryChange(e: any) {
    const searchProduct = e?.query;
    let params: any = {
      global_search: searchProduct,
      include_atlantic_products: true,
    };

    this._api
      .getReq(`/${API_VERSIONS.PRODUCTS}/products`, { params: params })
      .subscribe(
        (res) => {
          const suggestions = res?.data ? res?.data : [];
          this.suggestions = suggestions.map((item: any) => ({
            id: item?.id,
            label: item?.label,
          }));
          if (this.suggestions?.length === 0) {
            this.suggestions = [{ id: 0, label: 'No matching suggestions' }];
          }
        },
        (err) => {
          this.errHandle.errorHandling(err);
        }
      );
  }
  onSelected() {
    this.suggestions = [];
  }

  private initForm(): void {
    this.addUserForm = new FormGroup({
      fname: new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(this.validationService.alphaPattern),
      ]),
      lname: new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
      ]),
      send_invitation: new FormControl(false, []),
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(this.validationService?.emailPattern),
      ]),
      phone: new FormControl('', [
        Validators.required,
        Validators.pattern(this.validationService.validPhoneUS),
      ]),
      enable_claim_creation_notification: new FormControl(false),
      enable_claim_status_update_notification: new FormControl(false),
      navigation_tab_ids: new FormControl([
        NavigationTab.Information_Agent,
        NavigationTab.Dealerships_Agent,
        NavigationTab.Products_Agent,
        NavigationTab.Commissions_Agent,
        NavigationTab.Claims_Agent,
        NavigationTab.Contracts_Agent,
      ]),
    });
  }

  showHideSection() {
    this.permissions?.nativeElement?.classList.toggle('show');
  }
}
